export default __webpack_public_path__ + "static/media/yellowAnn.08001f76.svg";